<template>
	<div
		class="bg-color-slate-5 text-align-center pt-150 pb-150 display-flex-md align-items-center-md justify-content-center-md"
	>
		<div class="gamma-md delta"> Can't find what you're looking for? </div>
		<div class="ml-200-md mt-100-smo">
			<BaseLink :link="contactLink" class="button button-outline" />
		</div>
	</div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { Link } from 'types/layout';

interface Props {
	articleTitle?: string;
}

const props = withDefaults(defineProps<Props>(), {
	articleTitle: ''
});

const contactLink = computed((): Link => {
	const link: Link = {
		text: 'Contact support',
		router: 'contact'
	};

	if (props.articleTitle !== '') {
		link.query = { cta: props.articleTitle };
	}

	return link;
});
</script>
